import styled from 'styled-components';
import { ITimerProps } from '../../../types/timer';
import { devices } from '../../../styles/viewports';

export const TimerWrapper = styled.div<Pick<ITimerProps, 'color'>>`
  color: var(--base-color-${({ color }) => color});
`;

export const Line = styled.div<Pick<ITimerProps, 'color'>>`
  height: 1px;
  background-color: var(--base-color-${({ color }) => color});
  margin-top: 32px;

  @media ${devices.mobileAndTablet} {
    margin-top: 20px;
  }
`;

export const TitleWrapper = styled.div`
  margin-bottom: 16px;

  @media ${devices.mobileAndTablet} {
    margin-bottom: 8px;
  }
`;

export const ValuesWrapper = styled.div`
  font-size: var(--font-size-header-4);
  font-family: var(--font-family-header);
  font-feature-settings: var(--font-feature-settings-header);
  font-weight: var(--font-weight-header-4);
  letter-spacing: var(--letter-spacing-header-4);
  line-height: var(--line-height-header-4);
  text-transform: var(--text-transform-header);
  display: flex;

  @media ${devices.tablet} {
    font-size: var(--font-size-header-5);
  }
`;

export const TimerLabel = styled.div`
  font-family: var(--font-family-overline);
  font-size: var(--font-size-overline-1);
  font-weight: var(--font-weight-overline-1);
  line-height: var(--line-height-overline-1);
  letter-spacing: var(--letter-spacing-overline-1);
  text-transform: var(--text-transform-overline);
  margin-top: 4px;
`;

export const TimerValueSeparator = styled.div`
  margin: 0 20px;

  @media ${devices.tablet} {
    margin: 0 12px;
  }

  @media ${devices.mobile} {
    margin: 0 12px;
  }
`;

export const TimerValueWrapper = styled.div``;

export const TimerValue = styled.div``;
